import { z } from "zod";
import { baseEntitySchema } from "./base";

export const bookingStatusSchema = z.enum([
  "searching",
  "found",
  "on_hold",
  "ticketed",
  "failed",
  "cancelled",
]);
export type BookingStatus = z.infer<typeof bookingStatusSchema>;

export const bookingDataSchema = z.object({
  soId: z.string(),
  status: bookingStatusSchema,
  bookingStart: z.date().optional(),
  bookingEnd: z.date().optional(),
  ticketNumbers: z.array(z.string()).default([]),
  lastUpdatedAt: z.date(),
  notes: z.string().optional(),
});

export type BookingData = z.infer<typeof bookingDataSchema>;
export const bookingSchema = baseEntitySchema.merge(bookingDataSchema);
export type Booking = z.infer<typeof bookingSchema>;
